const VALID_PROPS = ['crossOrigin', 'dataset', 'integrity'];

export const loadScript = ({ async = true, domain = 'mirai', id, inline, src, onLoad = () => {}, ...others } = {}) =>
  new Promise((resolve, reject) => {
    const scriptId = `${domain}-${id}`;
    const exists = document.getElementById(scriptId);

    const cleanup = () => {
      const el = document.getElementById(scriptId);
      if (el) el.parentNode.removeChild(el);
    };

    if ((!inline && !src) || exists) return resolve(cleanup);

    const script = document.createElement('script');
    script.id = scriptId;
    script.async = async;
    Object.keys(others || {})
      .filter((key) => VALID_PROPS.includes(key))
      .forEach((key) => {
        if (key === 'dataset')
          Object.keys(others.dataset).forEach((dataKey) => (script.dataset[dataKey] = others.dataset[dataKey]));
        else script[key] = others[key];
      });

    if (src) script.src = src;
    else if (inline) script.textContent = inline;

    script.onerror = (error) => reject(error);

    script.onload = () => {
      if (src && inline) {
        const inlineScript = document.createElement('script');
        inlineScript.textContent = inline;
        document.head.appendChild(inlineScript);
      }

      onLoad();
      // eslint-disable-next-line no-console
      if (src) console.log(`📜 <script ${scriptId} ${src ? `src=${src} ` : ''}/>`);

      resolve(cleanup);
    };

    document.head.appendChild(script);
  });
